<template>
  <div class="map-subsection">
    <div class="map-container">
      <h2 class="map-title">Notre localisation</h2>
      <div class="map-wrapper">
        <iframe
          class="map-iframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.9916256937595!2d2.292292615674398!3d48.85837007928746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66fec70fb1d8f%3A0x40b82c3688c9460!2sEiffel%20Tower!5e0!3m2!1sen!2sfr!4v1234567890123!5m2!1sen!2sfr"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MapSubsection",
});
</script>

<style>
.map-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  padding: 80px 30px;
  position: relative;
  width: 100%;
}

.map-subsection .map-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 1200px;
  width: 100%;
}

.map-subsection .map-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 45px;
  text-align: center;
}

.map-subsection .map-wrapper {
  align-self: stretch;
  border-radius: 12px;
  height: 450px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.map-subsection .map-iframe {
  border: 0;
  height: 100%;
  width: 100%;
}
</style>
